import { Modal, type ModalProps } from "../../lib/modal";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

enum ModalVariant {
  GenericError,
  PaymentInfoUpdateSuccess,
  PaymentInfoUpdateFinished,
}

type ModalContents = {
  [_ in ModalVariant]: {
    title: string;
    description: React.ReactNode;
  };
};

const ModalContents: ModalContents = {
  [ModalVariant.PaymentInfoUpdateSuccess]: {
    title: "Successful update",
    description: "Payment information successfully updated.",
  },
  [ModalVariant.PaymentInfoUpdateFinished]: {
    title: "",
    description:
      "Your payment method will be updated soon. Please refresh the page to see if your subscription has been successfully renewed.",
  },
  [ModalVariant.GenericError]: {
    title: "Something went wrong",
    description: (
      <>
        Please refresh the page and try again, or submit a support ticket via{" "}
        <NewZendeskTicketLink>this link</NewZendeskTicketLink>.
      </>
    ),
  },
};

const WithVariant = (variant: ModalVariant) => {
  const content = ModalContents[variant];
  const ModalWithVariant = ({ open, onClose, telemetryName }: Omit<ModalProps, "children">) => (
    <Modal open={open} onClose={onClose} telemetryName={telemetryName} title={content.title}>
      <div>{content.description}</div>
    </Modal>
  );
  return ModalWithVariant;
};

export const GenericErrorModal = WithVariant(ModalVariant.GenericError);
export const PaymentInfoUpdateSuccessModal = WithVariant(ModalVariant.PaymentInfoUpdateSuccess);
export const PaymentInfoUpdateFinishedModal = WithVariant(ModalVariant.PaymentInfoUpdateFinished);
